export const addCategories = categories => ({
  type: 'ADD_CATEGORIES',
  categories: categories
});

export const addSubCategories = categories => ({
  type: 'ADD_SUBCATEGORIES',
  subcategories: categories
});

export const selectSubCategory = category => ({
  type: 'SELECT_SUBCATEGORY',
  category: category
});

export const removeSubCategories = () => ({
  type: 'REMOVE_SUBCATEGORIES'
});

export const addPreparations = preparations => ({
  type: 'ADD_PREPARATIONS',
  preparations: preparations
});

export const removePreparations = () => ({
  type: 'REMOVE_PREPARATIONS'
});

export const selectPreparation = preparation => ({
  type: 'SELECT_PREPARATION',
  preparation: preparation
});

export const addMixables = mixables => ({
  type: 'ADD_MIXABLES',
  mixables: mixables
});

export const removeMixables = () => ({
  type: 'REMOVE_MIXABLES'
});

export const selectMixable = mix => ({
  type: 'SELECT_MIXABLE',
  mix: mix
});
